module.exports = __webpack_public_path__ + "static/media/meta-image-horizontal.72f45de4.png";